import { memo } from "react";
import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

function IconEllipsis(props: SvgIconProps) {
  return (
    <SVGIcon width="16" height="4" viewBox="0 0 16 4" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="0.5" y="0.5" width="3" height="3" rx="1.5" fill="currentColor" />
      <rect x="6.5" y="0.5" width="3" height="3" rx="1.5" fill="currentColor" />
      <rect x="12.5" y="0.5" width="3" height="3" rx="1.5" fill="currentColor" />
    </SVGIcon>
  );
}

export default memo(IconEllipsis);
